import { render, staticRenderFns } from "./social-delivery.vue?vue&type=template&id=ee7847e6&scoped=true"
import script from "./social-delivery.vue?vue&type=script&lang=js"
export * from "./social-delivery.vue?vue&type=script&lang=js"
import style0 from "./social-delivery.vue?vue&type=style&index=0&id=ee7847e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7847e6",
  null
  
)

export default component.exports